import React, { forwardRef } from "react";

const FileInput = forwardRef(function FileInput(
  {
    label,
    handleFileChange,
    acceptFormat,
    required,
    id,
    name,
    imageURL,
    errorMessage,
    disabled,
    isFacilityNotes = false,
    isEcardNotes = false,
    isZoom = false,
    handleZoom,
  },
  ref // only used where passed
) {
  return (
    <>
      <div>
        <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">
          {label} {required && <span className="text-danger">*</span>}
        </label>
        <div>
          <input
            ref={ref}
            className={`form-control fs-5 ${
              errorMessage && errorMessage?.[name]?.trim()?.length > 0
                ? "input-error"
                : ""
            }`}
            type="file"
            id={id}
            name={name}
            accept={acceptFormat}
            onChange={handleFileChange}
            // required={required}
            disabled={disabled}
          />
        </div>
        {errorMessage &&
          errorMessage[name] &&
          Object?.keys(errorMessage).length > 0 && (
            <div className="text-danger fw-700 fs-6 mt-1">
              {/* {errorMessage && errorMessage[name + "-size"]
            ? errorMessage[name + "-size"]
            : ""}
          {errorMessage && errorMessage[name + "-type"]
            ? errorMessage[name + "-type"]
            : ""} */}
              {errorMessage && errorMessage[name] ? errorMessage[name] : ""}
            </div>
          )}
        {isFacilityNotes && (
          <div className="fs-6">
            <span className="text-gray">
              Note: Accepted Logo Formats .png, .jpg and .gif{" "}
              <span className="text-danger">*</span>
            </span>
          </div>
        )}
        {isEcardNotes && (
          <div className="fs-6">
            <span className="text-gray">
              Note: Accepted E-Card Formats .jpg, .jpeg and .png{" "}
              <span className="text-danger">*</span>
            </span>
          </div>
        )}
      </div>
      {imageURL && (
        <div className="col-md-3 mt-3">
          <img
            height={"100px"}
            width={"100px"}
            src={imageURL}
            alt=""
            onClick={isZoom ? handleZoom : undefined}
          />
        </div>
      )}
    </>
  );
});

export default FileInput;
